<template>
  <div class="home bg-donate">
    <div class="content">
      <div class="container-fluid">
        <div class="col-12">
          <h1 class="titillium-web-bold">Tarefa Solidária Jogos Interclasse</h1>
          <h4 class="titillium-web-light">Acompanhe os resultados da arrecadação de alimentos!</h4>
        </div>
        <div class="row pt-4">
          <div class="title-setor">Ensino Fundamental Anos Finais</div>

          <div class="col-3 pt-3" @click="redirect(6)">
            <div class="bg-sala-select text-center">6º ANO</div>
          </div>

          
          <div class="col-3 pt-3" @click="redirect(7)">
            <div class="bg-sala-select text-center">7º ANO</div>
          </div>

          
          <div class="col-3 pt-3" @click="redirect(8)">
            <div class="bg-sala-select text-center">8º ANO</div>
          </div>

          
          <div class="col-3 pt-3" @click="redirect(9)">
            <div class="bg-sala-select text-center">9º ANO</div>
          </div>

        <div class="col-12 mt-4"></div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { $firebase } from '../services/firebase'

export default {
  data() {
    return {
      server: "http://localhost:8080",
      email: "",
      password: "",
      loading: false,
      error: false,
      msg_error: "",
    };
  },
  methods: {
    redirect(param) {
    if(param >= 1 && param <=3){
      this.$router.push('/metas/EM'+param);

    }else{
      this.$router.push('/metas/EF'+param);
    }
    }

  },
  async mounted() {

  }
};
</script>
